import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import CallBack from './views/CallBack.vue'
import Home from './views/Home.vue'
import NewsList from './views/NewsList.vue'
import NewsDetail from './views/NewsDetail.vue'
import StaticFolderList from './views/StaticFolderList.vue'
import D3FolderList from './views/D3FolderList.vue'
import D2FolderList from './views/D2FolderList.vue'
import D1FolderList from './views/D1FolderList.vue'
import FolderList from './views/FolderList.vue'
import D3FolderDetail from './views/D3FolderDetail.vue'
import D2FolderDetail from './views/D2FolderDetail.vue'
import D1FolderDetail from './views/D1FolderDetail.vue'
import FolderDetail from './views/FolderDetail.vue'
import DutyDetail from './views/DutyDetail.vue'
import TransPort from './views/transport/TransPort.vue';
import NotFound from './views/NotFound.vue'
import Body from './views/Body.vue'
import Statistic from './views/Statistic/Statistic.vue';
import Roster from './views/Roster.vue';
import Application from './views/Application.vue'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      component: Body,
      children: [
        {
          path: '',
          name: 'Home',
          component: Home
        },
        {
          path: 'newslist/:name/:category?',
          name: 'NewsList',
          component: NewsList
        },
        {
          path: 'staticfolderlist/:name/:category?',
          name: 'StaticFolderList',
          component: StaticFolderList
        },
        {
          path: 'd3folderlist/:name/:category/:select',
          name: 'D3FolderList',
          component: D3FolderList
        },
        {
          path: 'd2folderlist/:name/:category',
          name: 'D2FolderList',
          component: D2FolderList
        },
        {
          path: 'd1folderlist/:name',
          name: 'D1FolderList',
          component: D1FolderList
        },
        {
          path: 'folderlist/:name',
          name: 'FolderList',
          component: FolderList
        },
        {
          path: 'newsdetail/:name/:id',
          name: 'NewsDetail',
          component: NewsDetail
        },
        {
          path: 'd3folderdetail/:name/:category/:select/:last',
          name: 'D3FolderDetail',
          component: D3FolderDetail
        },
        {
          path: 'd2folderdetail/:name/:category/:select',
          name: 'D2FolderDetail',
          component: D2FolderDetail
        },
        {
          path: 'd1folderdetail/:name/:category?',
          name: 'D1FolderDetail',
          component: D1FolderDetail
        },
        {
          path: 'folderdetail/:name',
          name: 'FolderDetail',
          component: FolderDetail
        },
        {
          path: 'dutydetail/:name/:title',
          name: 'DutyDetail',
          component: DutyDetail
        },
        {
          path: "transport",
          name: "TransPort",
          component: TransPort
        },
        {
          path: "statistic",
          name: "Statistic",
          component: Statistic,
        },
        {
          path: "roster",
          name: "Roster",
          component: Roster
        },

        {
          path: "application",
          name: "Application",
          component: Application,
        },

        {
          path: 'notfound',
          name: 'NotFound',
          component: NotFound
        }
      ],
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/callback',
      name: 'CallBack',
      component: CallBack
    },
    {
      path: '*',
      redirect: 'notfound'
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => {
    return record.meta.requireAuth
  })) {
    if (localStorage.getItem('access_token')) {
      const route = to.name
      switch (route) {
        case 'Home':
          document.body.className = 'body-dashboard'
          break
        default:
          document.body.className = 'body-regular'
      }
      next()
    } else {
      next({
        path: '/login'
      })
    }
  } else {
    const route = to.name
    switch (route) {
      case 'Login':
        document.body.className = 'body-login'
        break
    }
    next()
  }
})
export default router
